import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=0273c45a&scoped=true&"
import script from "./DownloadButton.vue?vue&type=script&lang=ts&"
export * from "./DownloadButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0273c45a",
  null
  
)

export default component.exports